import styled from "styled-components"
import { mq } from "styles"
import { $BgColor } from "typings/modules"

export const Container = styled.div<$BgColor>`
  background: ${({ $bgColor }) => $bgColor};
`

export const Content = styled.div`
  text-align: center;
  padding: 64px 0 32px;
  ${mq.minWidth("md")} {
    padding: 96px 0 64px;
  }
`
